"use strict";

exports.__esModule = true;
exports.default = void 0;

require("core-js/features/number/is-nan");

// Polyfill
var stripUnit = function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (Number.isNaN(unitlessValue)) return value;
  return unitlessValue;
};

var _default = stripUnit;
exports.default = _default;